export const errorCodes = {
  something_wrong: [
    2, 4, 5, 6, 9, 10, 12, 14, 17, 19, 20, 21, 1010, 1030, 1032, 1034, 1035,
    1036, 1050, 1051, 1052, 1054, 1055, 1058, 3000, 3002, 3004, 3007, 3008,
    3009, 3010, 4002, 7001, 8005, 8006, 8007, 8008, 8009, 11000,
  ],
  session_timeout: [3],
  auth_method_or_mfa_change: [31],
  incorrect_data: [1, 8, 1000],
  network_administrator: [7],
  signup_validation: [4],
  verify_email: [11],
  locked_account: [13],
  deactivated_account: [15, 16, 18],
  wrong_platform: [22],
  mfa_code_required: [33],
  mfa_code_invalid: [34],
  mfa_session_expired: [35],
  unlinked_email: [1000],
  invalid_file: [1000],
  csv_format_error: [1001],
  format_error: [1002],
  fields_error: [1003],
  otp_error: [1004],
  password_link: [1011, 1014],
  invalid_email: [1041],
  email_exists: [1042],
  sso_email_exists: [1044],
  blocked_email: [1080],
  incorrect_password: [1031],
  withdraw_period: [1033],
  withdraw_amount: [1057],
  missing_email: [1101],
  missing_employee_id: [1102],
  missing_company_id: [1103],
  decryption_error: [1201],
  limit_rows_exceeded: [1401],
  wrong_code: [1500],
  expired_code: [1501],
  used_code: [1502],
  missing_content: [
    4001, 5000, 5001, 5004, 5006, 5007, 7000, 8001, 8004, 8010, 8011, 8012,
    1103, 12001, 12002, 12003,
  ],
  re_recognised: [4003],
  upload_image: [11002],
  unavailable_badge: [13000],
  promoted_post: [21000],
  no_email: [1092],
  dependant_already_exists: [1042],
  dependant_already_limit: [1503],
} as const;

const constErrors = {
  '1056': 'USER_EMAIL_CONFIRMED_ALREADY',
  '5002': 'FEED_POST_ACTION_EXISTS',
  '5003': 'FEED_POST_ANNIVERSARY_USER_WORK_START_EMPTY',
  '5005': 'FEED_POST_STARTED_ON_EMPTY',
  '8013': 'BENEFIT_FAVORITE_ALREADY_ADDED',
  '8100': 'AFFILIATE_CAMPAIGN_NOT_FOUND',
  '8101': 'AFFILIATE_CAMPAIGN_GENERIC_WRO',
  '8102': 'AFFILIATE_CAMPAIGN_WRONG_DATE',
  '8103': 'AFFILIATE_CAMPAIGN_SIGN_UP_LIMIT',
  '8202': 'BILLING_BAD_REQUEST',
  '11001': 'GENERAL_IMAGE_UPLOAD_VALIDATION',
} as const;

export const parseErrorCode = (code: number) => code * -1;

export const getErrorType = (code: number) => {
  const finalCode = parseErrorCode(code);

  if (constErrors[finalCode]) {
    return constErrors[finalCode];
  }

  return Object.keys(errorCodes).filter(key =>
    errorCodes[key].includes(finalCode),
  )[0];
};
